const STATUS = {
  UNAUTHORIZED: 404,
  FORBIDDEN: 403,
};

export default STATUS;
